import { FC, FunctionComponent, SVGProps } from 'react';
import { NavLink } from 'react-router-dom';

import FolderIcon from '@/common/assets/icons/folder2Icon.svg?react';
import FolderSolidIcon from '@/common/assets/icons/folder2SolidIcon.svg?react';
import FolderAddIcon from '@/common/assets/icons/folderAddIcon.svg?react';
import FolderAddSolidIcon from '@/common/assets/icons/folderAddSolidIcon.svg?react';
import HomeIconIcon from '@/common/assets/icons/homeIcon.svg?react';
import HomeSolidIcon from '@/common/assets/icons/homeSolidIcon.svg?react';
import ProfileIcon from '@/common/assets/icons/profile.svg?react';
import SolidProfileIcon from '@/common/assets/icons/profileSolid.svg?react';
import { DASHBOARD_LINKS } from '@/modules/Dashboard/DashboardLinks.ts';
import { FILE_LIST_LINKS } from '@/modules/FileList/fileListLinks.ts';
import { css, cx } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { center } from 'styled-system/patterns';
import { token } from 'styled-system/tokens';

const NavigationBar = () => {
  return (
    <Box
      zIndex={'modal'}
      position="fixed"
      bottom={0}
      left={0}
      w="100%"
      px="4px"
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        height="66px"
        bg={'white'}
        maxWidth="maxContainer"
        mx={'auto'}
      >
        <LinkIcon
          url={DASHBOARD_LINKS.homePage}
          Icon={HomeIconIcon}
          SolidIcon={HomeSolidIcon}
          text="خانه"
        />
        <LinkIcon
          url={FILE_LIST_LINKS.newFiles}
          Icon={FolderAddIcon}
          SolidIcon={FolderAddSolidIcon}
          text="پیشنهاد کارشناسی"
        />
        <LinkIcon
          url={FILE_LIST_LINKS.myFiles}
          Icon={FolderIcon}
          SolidIcon={FolderSolidIcon}
          text="پرونده های من"
        />
        <LinkIcon
          url={DASHBOARD_LINKS.profile}
          Icon={ProfileIcon}
          SolidIcon={SolidProfileIcon}
          text="پروفایل"
        />
      </Flex>
    </Box>
  );
};

export default NavigationBar;

type LinkIconProps = {
  text: string;
  url: string;
  Icon: FunctionComponent<
    SVGProps<SVGSVGElement> & { title?: string | undefined }
  >;
  SolidIcon: FunctionComponent<
    SVGProps<SVGSVGElement> & { title?: string | undefined }
  >;
};

const LinkIcon: FC<LinkIconProps> = ({ text, Icon, SolidIcon, url }) => {
  const solidColor = token('colors.purple-primary');
  const styles = {
    text: css({
      color: 'black-3',
      textStyle: 'b4',
      whiteSpace: 'nowrap',
    }),
    solidText: css({ color: 'purple-primary' }),
    navBar: center({ flexDir: 'column', flex: 1, width: '25%' }),
  };

  return (
    <NavLink to={url} className={styles.navBar}>
      {({ isActive }) => {
        return isActive ? (
          <>
            <SolidIcon fill={solidColor} />
            <p className={cx(styles.text, styles.solidText)}>{text} </p>
          </>
        ) : (
          <>
            <Icon />
            <p className={styles.text}>{text} </p>
          </>
        );
      }}
    </NavLink>
  );
};
